<script setup>
// Thin wrapper around saas-core's UserProfile (hoisted in-core in alpha.11;
// friction-free password change in alpha.13). i-Recall's local 278-line
// profile page was deleted in the alpha.13 adoption — only the post-deletion
// redirect stays app-side, since saas-core is deliberately hands-off about
// routing.
import UserProfile from "@digitalstreams/saas-core/vue/views/UserProfile.vue";
import { useRouter } from "vue-router";

const router = useRouter();
</script>

<template>
  <UserProfile
    forgot-password-to="/forgot-password"
    @deleted="router.push('/topics')"
  />
</template>

<style scoped>
/* saas-core's UserProfile hard-codes `max-width: 820px` (inline) on its root
   .container-fluid, which — because .container-fluid carries margin:auto —
   shrinks + centres the page. Override so Profile fills the content area
   left-aligned, matching the rest of the consumer surface (HomeDashboard,
   Topics, Library, Settings, Team). !important is required to beat the inline
   style; at full width the auto side-margins collapse to 0 on their own. */
:deep(.container-fluid) {
  max-width: none !important;
}
</style>
